import React, { useState, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function AnnouncemenForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/addannouncement`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        //

        setTimeout(() => {
          setShowToast(false);
          navigate("/AnnouncementList");
        }, 3000);
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          title: "",
          message: "",
          // status: "inactive", // Default to inactive
        }}
        validationSchema={Yup.object({
          title: Yup.string().required("Title name is required"),
          message: Yup.string().required("Message is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start pb-2">Announcement</h4>
            <div className="col-lg-12 mt-1 m-3">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row h-75">
                  <div className="col-lg-5">
                    <label className="formlabel">
                      Title<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.title && errors.title ? "is-invalid" : ""
                      }`}
                      placeholder="Enter title"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.title && errors.title && (
                      <div className="text-danger">{errors.title}</div>
                    )}
                  </div>

                  <div className="col-lg-5 ml-5">
                    <label>Message</label>
                    <textarea
                      className={`form-control ${
                        touched.message && errors.message ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Message"
                      name="message"
                      rows="6"
                      value={values.message}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.message && errors.message && (
                      <div className="text-danger">{errors.message}</div>
                    )}
                  </div>

                  {/* <div className="col-lg-2">
                <label className="formlabel">Status</label>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="active"
                    name="status"
                    value="active"
                    checked={values.status === "active"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <label className="form-check-label" htmlFor="active">
                    Active
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="inactive"
                    name="status"
                    value="inactive"
                    checked={values.status === "inactive"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <label className="form-check-label" htmlFor="inactive">
                    Inactive
                  </label>
                </div>
              </div> */}
                </div>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a href="/createtemplate" className="text-decoration-none">
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>
      <div>
        {/* Your existing component code */}

        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default AnnouncemenForm;
